import {
  getData,
  saveData
} from '@/api/local_storage'

const getCaseData = function (key) {
  let data = {
    sourceData: getData('source_data' + key),
    assignData: getData('assign_data' + key),
    parmData: getData('parm_data' + key),
    routeData: getData('solution_data' + key)
  }
  return data
}

const state = {
  case_list: [],
  active_case: {
    // new 新建的 old 纪录中的
    status: '',
    name: '',
    key: '',
    solutionStatus: ''
  }
}

const getters = {
  caseList: state => state.case_list,
  activeCase: state => state.active_case,
  caseName: state => state.active_case.name
}

const actions = {
  saveCaseFail ({dispatch}, key) {
    // case存储失败 需要提示，然后清除该case 相关localstorage 数据
    dispatch('showNoticeMsg', {
      type: 'warning',
      title: 'case存储失败',
      message: '由于浏览器存储空间不足或其他原因，该case存储失败！'
    })
    dispatch('clearCaseStoreData', key)
  },
  clearCaseStoreData ({dispatch}, key) {
    dispatch('clearSourceData', key)
    dispatch('clearAssignData', key)
    dispatch('clearParmData', key)
    dispatch('clearRouteData', key)
  },
  getCaseList ({commit}, data) {
    commit('changeCaseList', getData('case_list') || [])
  },
  setCaseName ({commit}, data) {
    commit('changeCaseName', data)
  },
  addCase ({commit, dispatch}, data) {
    // 初始化数据  包括 原始数据、配置数据、客户分配数据、路径分配数据
    dispatch('setSolutionStatus', 0)
    dispatch('initCaseData', {})
    commit('newCase', data)
  },
  saveCase ({commit, dispatch, getters, state}) {
    let key = state.active_case.key
    try {
      dispatch('saveSourceData', key)
      dispatch('saveAssignData', key)
      dispatch('saveParmData', key)
      dispatch('saveRouteData', key)
      commit('changeCaseStatus', {key: key, status: 'old'})
      saveData({key: 'case_list', data: getters.caseList})
      dispatch('showNoticeMsg', {
        type: 'success',
        title: 'case存储成功',
        message: '您可以在数据导入中自由切换该case！'
      })
    } catch (error) {
      dispatch('saveCaseFail', key)
    }
  },
  switchCase ({commit, dispatch, getters}, switchKey) {
    window.myChat.clear()
    dispatch('setSourceDataType', (switchKey.indexOf('oil') !== -1 ? 'oil' : 'shop'))
    dispatch('setLoading', true)
    dispatch('setLoadingText', '切换case中')
    dispatch('setPercentage', {'start': 0, 'next': 100})
    if (getters.activeCase.status === 'new') {
      commit('delCaseList')
    }
    commit('changeActiveCase', switchKey)
    // 提取数据 原始数据、配置数据、客户分配数据、路径分配数据
    let caseData = getCaseData(switchKey)
    // 初始化数据  包括 原始数据、配置数据、客户分配数据、路径分配数据
    dispatch('initCaseData', caseData)
    dispatch('setLoadingText', 'case切换完成')
    dispatch('setLoading', false)
    dispatch('setPercentage', {'start': 100, 'next': 100})
  },
  initCaseData ({ dispatch }, data) {
    dispatch('clearMapOption')
    dispatch('initSourceData', data.sourceData || 'clear')
    dispatch('initAssignData', data.assignData || 'clear')
    dispatch('initParmData', data.parmData || 'clear')
    dispatch('setSolutionData', data.routeData || 'clear')
  }
}

const mutations = {
  changeActiveCase (state, data) {
    state.case_list.forEach(function (item) {
      if (item.key === data) {
        state.active_case = item
      }
    })
  },
  newCase (state, data) {
    let newCase = {
      key: (data === '石化DEMO' ? 'oil' : 'shop') + String(new Date().getTime()),
      name: data || 'new case',
      status: 'new'
    }
    state.active_case = newCase
    state.case_list.push(newCase)
  },
  changeCaseList (state, data) {
    state.case_list = data
  },
  changeCaseName (state, data) {
    state.active_case.name = data
  },
  changeCaseStatus (state, data) {
    state.case_list.forEach(function (item) {
      if (item.key === data.key) {
        item.status = data.status
      }
    })
    if (data.key === state.active_case.key) {
      state.active_case.status = data.status
    }
  },
  delCaseList (state) {
    let data = state.active_case
    let newCaseList = []
    state.case_list.forEach(function (item) {
      if (item.key !== data.key) {
        newCaseList.push(item)
      }
    })
    state.case_list = newCaseList
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/case.js